module.exports = __webpack_public_path__ + "01_cheek.c357ebc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer2/01_cheek.png
// module id = NtVq
// module chunks = 0